<template>
  <span class="f360-iconia">
    <img
      :src="iaIcon"
      alt="inteligência artificial"
      class="f360-iconia__icon"
    />
  </span>
</template>

<script setup lang="ts">
import iaIcon from "@/ui/assets/financas/insigths/icone-ia-white.svg";
</script>

<style scoped lang="scss">
.f360-iconia {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: _map.get($map: $azulPrincipal, $key: 700);
  color: _map.get($map: $neutro, $key: 0);
}
</style>
